export default {
    events: [],
    notes: [],
    qbToken: '',
    qbRefreshToken: '',
    manageEventDialog: false,
    manageNoteDialog: false
}
